import React from 'react';
import { IonIcon } from '@ionic/react';
import { arrowBackOutline } from 'ionicons/icons';
import { useHistory } from 'react-router-dom';

interface PageHeaderProps {
    title: string;
    subtitle?: React.ReactNode;
    /** Ruta a la que volver si no hay historial (p. ej. al recargar la página). */
    backHref?: string;
    disabled?: boolean;
    /** Botones opcionales a la derecha del título. */
    actions?: React.ReactNode;
}

/** Encabezado común de las pantallas internas: botón volver + título + subtítulo. */
export function PageHeader({ title, subtitle, backHref = '/panel', disabled, actions }: PageHeaderProps) {
    const history = useHistory();

    const goBack = () => {
        if (history.length > 1) {
            history.goBack();
        } else {
            history.replace(backHref);
        }
    };

    return (
        <div className="page-header">
            <button className="back-btn" onClick={goBack} disabled={disabled} title="Volver">
                <IonIcon icon={arrowBackOutline} />
            </button>
            <div className="header-title-section">
                <h2>{title}</h2>
                {subtitle && <p>{subtitle}</p>}
            </div>
            {actions && <div className="page-header-actions">{actions}</div>}
        </div>
    );
}

/** Fondo decorativo. `auth` usa el degradado de marca (login, registro, recuperar). */
export function AppBackground({ variant = 'light' }: { variant?: 'light' | 'auth' }) {
    return (
        <div className={`app-bg${variant === 'auth' ? ' app-bg--auth' : ''}`}>
            <div className="app-bubble app-bubble-1" />
            <div className="app-bubble app-bubble-2" />
        </div>
    );
}
